import React, { useEffect } from 'react';
import './home.css';
import { useSelector } from 'react-redux';
import Navigation from '../../components/navigation/Navigation.jsx';
import IntroVideo from '../../assets/team-connect-cwp_2.mp4';
import { useNavigate } from 'react-router-dom';
export default function GetHone() {
    const { siteUserId } = useSelector(state => state.auth);
    const { isAuthenticated } = useSelector(state => state.auth);
    const navigate = useNavigate();
  useEffect(() => {
      document.title = 'Appointment Reminder System'
      navigate("/login");
  }, [isAuthenticated, siteUserId]);

  return (
      <div className="home-page-wrap">
      <Navigation />
      <div className="home-page-video-wrap">
        {/*<iframe className="home-page-video" src="https://player.vimeo.com/video/783455878?h=46672b3b96&title=0&byline=0&portrait=0&background=1" width="360" height="640" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>*/}
        <video className="home-page-video" autoPlay muted loop playsInline>
          <source src={IntroVideo} type="video/mp4" />
        </video>
      </div>
    </div>
  );
}
